import axios from "axios";

export const api = axios.create({
  production: true,
  baseURL: "https://sesat1.sefaz.pb.gov.br/esat/api",
  /* 
  app_user: "gecapv1",
  app_pass: "yn%i&<v-LQ}:DzE@+Wqw<al0u@bMq<khrt>@Z}`#|bmd3q0f>#P[g}$0d}5h~{}#v)VjlZ=G7WM][K1-sYan", */
});
